import(/* webpackMode: "eager", webpackExports: ["LogoGeneratorView"] */ "/app/apps/nextjs/src/modules/main/presentation/default/views/logo-generator/logo-generator.view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/modules/main/presentation/navigation/views/base-navigation/base-navigation.layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/modules/main/presentation/navigation/views/sidebar-navigation/sidebar-navigation.layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/modules/main/presentation/navigation/views/topbar-navigation/topbar-navigation.layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useAppConfigContext"] */ "/app/node_modules/@constructr-sdk/core/dist/config/context/app-config-context.jsx");
